import './style.scss'
import React from 'react'
import { Text, tokens, UIProps } from 'src/componentv2/Base/ui'

export interface SelectOption {
    label: string
    value: string
}

export interface SelectFieldProps extends UIProps {
    label?: React.ReactNode
    placeholder?: string
    helperText?: React.ReactNode
    value?: string
    onChange?: (value: string, e: React.ChangeEvent<HTMLSelectElement>) => void
    name?: string
    options?: SelectOption[]
    error?: React.ReactNode
    disabled?: boolean
    required?: boolean
}

export const SelectField: React.FC<SelectFieldProps> = ({
                                                            label, placeholder, helperText, value, onChange, name,
                                                            options = [], error, disabled, required,
                                                            width = '100%', className = '',
                                                        }) => (
    <div
        className={`select-field ${error ? 'select-field--error' : ''} ${className}`}
        style={{ width }}
    >
        {label && (
            <label className="select-field__label">
                {label}{required && <span className="select-field__req"> *</span>}
            </label>
        )}

        <div className="select-field__control">
            <select
                className="select-field__input"
                name={name}
                value={value}
                disabled={disabled}
                onChange={(e) => onChange?.(e.target.value, e)}
            >
                {placeholder && (
                    <option value="" disabled hidden>
                        {placeholder}
                    </option>
                )}
                {options.map((opt) => (
                    <option key={opt.value} value={opt.value}>
                        {opt.label}
                    </option>
                ))}
            </select>
            <span className="select-field__chevron">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M4 6L8 10L12 6" stroke="#667085" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
            </span>
        </div>

        {(error || helperText) && (
            <Text
                className="select-field__helper"
                fontSize="1.3"
                topMargin="0.6"
                color={error ? '#D92D20' : tokens.textMuted}
            >
                {error || helperText}
            </Text>
        )}
    </div>
)

export default SelectField